import React, { useEffect } from "react"
import propTypes from "prop-types"
import { Modal, ModalBody, ModalHeader } from "reactstrap"
import { useMutation, useQuery } from "@tanstack/react-query"

import ProductsForm from "../ProductsForm"
import { convertProductPresentationToProduct } from "services/product-presentations"
import { getAllPrices } from "services/prices"
import { normalizePriceQuantity, normalizePriceUtility, parseCurrencyValue } from "../productPayloadHelpers"

const ConvertModalFormPresentation = ({
  isOpen,
  toggle,
  product,
  presentation,
  refetch,
  setShowAlertSuccess,
  setMsgSuccess,
}) => {
  const prices = useQuery(["prices"], () => getAllPrices())
  const { isLoading, isError, error, isSuccess, mutateAsync } = useMutation((payload) =>
    convertProductPresentationToProduct(presentation?.id, payload)
  )

  const initialData = {
    name: presentation?.description || "",
    providers: product?.providers || [],
    bar_code: presentation?.key || "",
    sat_code: product?.sat_code || "",
    cost: String(product?.cost ?? ""),
    brand: product?.brand || undefined,
    prices: product?.prices || [],
    unit_measurement: product?.unit_measurement || undefined,
    taxes: product?.taxes || [],
  }

  const submit = async (data) => {
    const dataTemp = { ...data }
    dataTemp.providers = dataTemp.providers ? dataTemp.providers?.map((provider) => provider.id) : []
    dataTemp.brand = dataTemp?.brand?.value || null
    dataTemp.cost = parseCurrencyValue(dataTemp.cost) || null
    dataTemp.unit_measurement = dataTemp?.unit_measurement?.value || null
    dataTemp.prices = dataTemp.prices || []
    dataTemp.prices.forEach((item, index) => {
      dataTemp.prices[index].amount = parseCurrencyValue(item.amount)
      dataTemp.prices[index].quantity = normalizePriceQuantity(item.quantity, index)
      dataTemp.prices[index].utility = normalizePriceUtility(item.utility)
    })
    dataTemp.taxes = dataTemp.taxes ? dataTemp.taxes?.map((tax) => tax.id) : []
    await mutateAsync(dataTemp)
  }

  useEffect(() => {
    if (isSuccess) {
      setMsgSuccess("Presentacion convertida en producto satisfactoriamente")
      setShowAlertSuccess(true)
      refetch()
      toggle()
    }
  }, [isSuccess])

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered={true} size="xl" backdrop="static">
      <ModalHeader toggle={toggle} charcode="X">
        Convertir presentacion en producto
      </ModalHeader>
      <ModalBody>
        <ProductsForm
          isRetrivePage={false}
          submit={submit}
          toggle={toggle}
          isLoading={isLoading}
          isError={isError}
          error={error}
          data={initialData}
          prices={prices}
        />
      </ModalBody>
    </Modal>
  )
}

ConvertModalFormPresentation.propTypes = {
  isOpen: propTypes.any,
  toggle: propTypes.func,
  product: propTypes.object,
  presentation: propTypes.object,
  refetch: propTypes.func,
  setShowAlertSuccess: propTypes.func,
  setMsgSuccess: propTypes.func,
}

export default ConvertModalFormPresentation
